var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1095 2.83815L17.1722 0.89409C16.5984 0.317847 15.8348 0 15.0222 0C14.2096 0 13.4459 0.317379 12.8722 0.893622L2.10155 11.7009C2.05724 11.7453 2.02085 11.7954 1.98913 11.8474C1.9798 11.8624 1.9728 11.8774 1.96441 11.8933C1.94201 11.9363 1.92336 11.9808 1.90936 12.0267C1.9061 12.0365 1.89957 12.0459 1.89723 12.0562L0.0275735 18.9964C-0.0465972 19.2716 0.0313052 19.5656 0.231892 19.7669C0.382566 19.9176 0.585019 20 0.792604 20C0.861643 20 0.931148 19.9906 0.999255 19.9724L7.61817 18.1767C7.67088 18.1875 7.72499 18.1936 7.77864 18.1936C7.98202 18.1936 8.18448 18.1159 8.33935 17.9604L19.1095 7.15366C19.6837 6.57741 20.0005 5.81065 20 4.99567C20.0005 4.18069 19.6842 3.41439 19.1095 2.83815ZM7.77911 16.2724L3.78415 12.2635L12.2877 3.73037L16.2831 7.73879L7.77911 16.2724ZM1.91869 18.0747L3.0709 13.7985L6.18 16.9184L1.91869 18.0747ZM17.9881 6.02832L17.405 6.61346L13.4095 2.60503L13.9936 2.01943C14.5431 1.46799 15.5012 1.46799 16.0508 2.01943L17.9881 3.96395C18.2628 4.23967 18.4144 4.60667 18.4144 4.99661C18.4144 5.38654 18.2633 5.7526 17.9881 6.02832Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.183 6.71909L7.20654 11.7129L8.32803 12.8383L13.3045 7.84449L12.183 6.71909Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNft);
export default __webpack_public_path__ + "static/media/EditNft.ef94687c57381583b29f520feb9899a5.svg";
export { ForwardRef as ReactComponent };